import axiosClient from "./axiosClient";
import AppCookie from '../helpers/AppCookie';


class PackageModel {
    constructor(){
        this.api_url = "/api/package";
    }

    async all(credentials) {
        const res = await axiosClient.get(this.api_url, {
            params: {
              bank_code: credentials.bank_code,
            },
          });
        return res;
    }
    
    async buyPackage(credentials) {
        const res = await axiosClient.post(this.api_url + "/buy", credentials );
        return res;
    }

    async getCurrentPackage() {
        const res = await axiosClient.get(this.api_url + "/get-current-package");
        return res;
    }

    async deletePackageApp(credentials) {
        const res = await axiosClient.post(this.api_url + "/delete-app", credentials );
        return res;
    }


    async getReport(credentials) {
        const res = await axiosClient.get(this.api_url + "/report", {
            params: {
                search: credentials.search,
                type: credentials.type,
                page: credentials.page,
                isExpired: credentials.isExpired,
                perPage: credentials.perPage,
                bank: credentials.bank
            },
        });
        return res;
    }

    async getTotal() {
        const res = await axiosClient.get(this.api_url + "/get-total");
        return res;
    }
}

export default new PackageModel;